module.exports = __webpack_public_path__ + "static/media/pinturas-faciais@2x.fac4bd2a.jpg";